/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）。
 * 作用：向各 section 组件下发 getConstants() 取词结果，避免逐层 props 透传。
 * 注意事项：由根组件 index.jsx 通过 Provider 注入；默认值为空对象，各消费方需做字段防御。
 */
import { createContext } from 'react';

const ConstantsContext = createContext({});

export default ConstantsContext;
